export default __webpack_public_path__ + "static/media/manas.55e1ad8b.svg";